export enum chatBotProductEnum {
  M3 = "M3",
  SELF_ONBOARDING = "selfOnboarding",
  ECOMMERCE = "ecommerce",
  D2C = "M3_D2C",
}
